import type { Lang } from "@/i18n";

/**
 * Best-effort sync of the user's language choice to their account so backend
 * emails/notifications render in the same language. Never throws: a failure to
 * persist the preference must not break the UI language switch (which is
 * already applied client-side via localStorage).
 */
export async function updateLanguagePreference(lang: Lang): Promise<void> {
  try {
    await fetch("/api/auth/language", {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ language: lang }),
    });
  } catch {
    /* ignore — client-side language already applied */
  }
}
